import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { useBackordersDashboardFilters } from "modules/BackordersDashboard/components/BackordersDashboardFilters/hooks";
import { useBackordersDashboardListeners } from "modules/BackordersDashboard/listeners";
import { BackordersDashboardQueryKeys } from "modules/BackordersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useBackordersQuery = () => {
  const { reg_vin_filter: _reg_vin_filter, ...filters } = useBackordersDashboardFilters();
  const listeners = useBackordersDashboardListeners();

  const isEnabled = !(filters.dealer_ids.length === 0 && filters.location_ids.length === 0);

  const { data, isFetching, refetch } = useRealTimeTypedQuery({
    queryKey: BackordersDashboardQueryKeys.backorders,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { ...filters }, baseUrl)).data,
    enabled: isEnabled,
    listeners,
    refetchOnDependencies: [isEnabled, JSON.stringify(filters)]
  });

  return { backordersData: data?.items || [], nbItems: data?.nb_items || 0, nbPages: data?.nb_pages || 1, isFetching, refetch };
};
